import JobTitleAutocompleteInput from '../inputs/JobTitleAutocompleteInput';
import createField from './createField';

const JobTitleAutocompleteField = createField(JobTitleAutocompleteInput);

export default JobTitleAutocompleteField;
